import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import AdjustmentInfoPerilakuKerja from '../AdjustmentInfoPerilakuKerja'

import type { HTMLProps } from 'react'

interface PanelPerilakuKerjaProps extends HTMLProps<HTMLDivElement> {
  adjustmentText?: string
  title?: string
  titleIndikatorPerilaku?: string
  originalIndikatorPerilaku?: string
  indikatorPerilaku?: string
  titlePerwujudanPerilaku?: string
  originalPerwujudanPerilaku?: string
  perwujudanPerilaku?: string
  className?: string
  originalAdjustmentLabel?: string
  reviewAdjustmentLabel?: string
}

const PanelPerilakuKerja = ({
  adjustmentText = 'Ada penyesuaian',
  title = '',
  titleIndikatorPerilaku = 'Indikator Perilaku',
  originalIndikatorPerilaku = '',
  indikatorPerilaku = '',
  titlePerwujudanPerilaku = 'Ekspektasi Khusus Pimpinan',
  originalPerwujudanPerilaku = '',
  perwujudanPerilaku = '',
  className = '',
  originalAdjustmentLabel = 'Perencanaan Guru',
  reviewAdjustmentLabel = 'Penyesuaian dari Kepala Sekolah',
  ...otherProps
}: PanelPerilakuKerjaProps) => {
  const isChanged =
    !!originalIndikatorPerilaku &&
    !!originalPerwujudanPerilaku &&
    (originalIndikatorPerilaku !== indikatorPerilaku ||
      originalPerwujudanPerilaku !== perwujudanPerilaku)

  return (
    <div
      data-testid="panel-perilaku-kerja"
      className={clsx('border border-gray-30 rounded p-6', className)}
      {...otherProps}
    >
      {isChanged && (
        <AdjustmentInfoPerilakuKerja
          text={adjustmentText}
          className="mb-6"
          title={title}
          originalIndikatorPerilaku={originalIndikatorPerilaku}
          indikatorPerilaku={indikatorPerilaku}
          originalPerwujudanPerilaku={originalPerwujudanPerilaku}
          perwujudanPerilaku={perwujudanPerilaku}
          originalLabel={originalAdjustmentLabel}
          reviewLabel={reviewAdjustmentLabel}
        />
      )}

      <Text variant="heading-lg">{title}</Text>
      <Text color="subdued" className="mb-1 mt-6">
        {titleIndikatorPerilaku}
      </Text>
      <Text variant="action" className="mb-1">
        {indikatorPerilaku}
      </Text>
      <Text color="subdued" className="mb-1 mt-6">
        {titlePerwujudanPerilaku}
      </Text>
      <Text variant="action" className="mb-1">
        {perwujudanPerilaku}
      </Text>
    </div>
  )
}

export default PanelPerilakuKerja
